<template>
    <div class="sub-nav">
        <div class="sub-nav--inner">
            <ul class="u-reset sub-nav--list" v-menu-aim="menuAim">
                <li v-for="(item, idx) in child.children" class="sub-nav--item">
                    <cmp-sub-nav-item class="sub-nav--el" facet="sub-nav" ref="row"
                            :level="1" :child="item" :idx="idx">
                    </cmp-sub-nav-item>
                </li>
            </ul>
            <cmp-sub-nav-flyout :level="1" :is-fixed="isFixed" class="sub-nav--flyout"></cmp-sub-nav-flyout>
            <cmp-sub-nav-flyout :level="2" :is-fixed="isFixed" class="sub-nav--final-row"></cmp-sub-nav-flyout>
        </div>
    </div>
</template>

<script>
    import navItemMixin from 'vue/mixins/nav-item';


    export default {
        mixins: [navItemMixin],
        props: {
            facet: String,
            child: Object,
            isFixed: Boolean,
        },
        data() {
            return {
                menuAim: {
                    row: null,
                    mouseLeave: this.onMouseLeave,
                    mouseEnter: this.onMouseEnter,
                    isFixed: this.isFixed,
                },
            };
        },
        methods: {
            onMouseLeave() {
            },
            onMouseEnter(id) {
                const $child = this.$refs.row[id];
                $child && $child.updateNav(true);
            },
        },
        mounted() {
            this.$set(this.menuAim, 'row', this.$refs.row);
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?5a90f3a6